import React from "react";
import { env } from "../config";

function CloudStackCards(props: any) {
    const { title, description, Features } = props;
    return (
        <div className="bg-[#FEF2E4] font-custom">
            <div
                className={`text-black-75   px-5 py-7 lg:px-10 xl:px-20 lg:py-14 mx-auto max-w-screen-2xl `}
            >
                <div
                    className={`text-2xl md:text-4xl lg:text-5xl flex justify-center mb-3 mx-auto  leading-loose text-center font-custom font-bold`}
                >
                    {title}
                </div>
                <div className="lg:text-lg md:text-base  font-normal  pt-2  text-center mb-7">
                    {description}
                </div>

                <div className=" grid  md:grid-cols-2 gap-3 ">
                    {Features?.map((node: any, index: number) => {
                        return (
                            <div
                                data-aos="fade-left"
                                data-aos-delay={`${index === 0 ? 150 : index * 150}`}
                                className={`  p-6 rounded-[10px] bg-white  md:h-[300px] lg:h-auto flex flex-col  md:text-left md:items-start justify-evenly`}
                            >
                                {node?.Image?.data?.attributes?.url && (
                                    <img
                                        className="w-max"
                                        src={`${env}${node?.Image?.data?.attributes?.url}`}
                                        alt="not available"
                                    />
                                )}

                                <div className="font-bold font-custom  md:text-base text-base py-3">
                                    {node?.Title}
                                </div>
                                <div className="font-custom md:text-base text-base  ">
                                    {node?.Description}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default CloudStackCards;
